import { getIsApiPending } from '../../../selectors/personalAccident/payloadCollection';
import {
    apiTransitionPayloadCollection,
    submitPayloadDataSuccess,
    submitPayloadDataFailure,
} from '../../../actions/personalAccident/payloadCollection';
import { getAccessToken, getPaymentStatusData, getPaymentMode } from '../../../selectors/personalAccident/payments';
import axios from 'axios';
import { triggerConfirmOrder, setBankDetailsSuccess } from '../../../actions/personalAccident/payments';
import { getStatusApiCallStatus } from '../../../selectors/personalAccident/payments';
import { getCustomerIdValue } from '../../../selectors/personalAccident/personalDetails';

export const paymentDetailsSubmitService = (store, next, action) => {
    (async () => {
        if (!getIsApiPending(store.getState())) {
            store.dispatch(apiTransitionPayloadCollection.pending());
            try {
                const resp = await makeSubmission(store.getState());

                store.dispatch(submitPayloadDataSuccess(resp.data));
                store.dispatch(apiTransitionPayloadCollection.success());

                const modeOfPayment = getPaymentMode(store.getState());
                const paymentStatus = getStatusApiCallStatus(store.getState());

                if (modeOfPayment === 'Mpesa' && paymentStatus === 'success') {
                    store.dispatch(triggerConfirmOrder());
                } else {
                    store.dispatch(setBankDetailsSuccess(true));
                }
            } catch (e) {
                console.error(e);
                store.dispatch(submitPayloadDataFailure(e));
                store.dispatch(apiTransitionPayloadCollection.failure());
            }
        }
    })();
    return next(action);
};

const payloadCollection = (state) => {
    const modeOfPayment = getPaymentMode(state);
    const paymentsData = getPaymentStatusData(state);
    const paymentStatus = getStatusApiCallStatus(state);
    const customerId = getCustomerIdValue(state);

    const payload = {
        id: customerId.value,
        paymentReference:
            paymentStatus === 'success'
                ? paymentsData?.CheckoutRequestID
                    ? paymentsData.CheckoutRequestID
                    : 'N/A'
                : 'N/A',

        modeOfPayment,
    };

    return {
        ...payload,
    };
};

const makeSubmission = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/personal-accident/payment-details';
        return await axios.post(url, payloadCollection(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};


export const paymentFailedDetailsSubmitService = (store, next, action) => {
    (async () => {
        if (!getIsApiPending(store.getState())) {
            store.dispatch(apiTransitionPayloadCollection.pending());
            try {
                await makeSubmission(store.getState());
                store.dispatch(apiTransitionPayloadCollection.success());

            } catch (e) {
                console.error(e);
                store.dispatch(submitPayloadDataFailure(e));
                store.dispatch(apiTransitionPayloadCollection.failure());
            }
        }
    })();
    return next(action);
};